"use client";
import React, { useState } from "react";
import Image from "next/image";
import { Collapse } from "antd";
import Link from "next/link";
import styled from "styled-components";

import close from "@/assets/closeIcon.svg";
import open from "@/assets/openIcon.svg";
import avatar from "@/assets/Avatar group.svg";

const { Panel } = Collapse;

const items: any[] = [
  {
    key: "1",
    label: "Tôi nên dùng ảnh nào trên Teklove?",
    children: (
      <div className="text-secondary text-[16px]">
        <p>
          Hãy tải ảnh lên Teklove thể hiện chính con người đã thu hút mọi người muốn gặp: người đó là bạn! Đừng mất công
          đưa mấy ảnh bạn bè vì đây không phải là nơi tung hô tình bằng hữu, cũng đừng tải ảnh đeo kính râm vì chúng che
          mất khuôn mặt của bạn. Những bức ảnh rõ nét là tuyệt nhất, có người nói một nụ cười rạng rỡ sẽ có sức hút
          trường tồn ở đây.
        </p>
      </div>
    ),
    showArrow: false,
  },
  {
    key: "2",
    label: "Tôi nên viết gì vào phần tiểu sử của mình?",
    children: (
      <div className="text-secondary text-[16px]">
        Tiểu sử là bức hình chụp nhanh thể hiện bạn là ai. Nếu không phải là người giỏi viết lách, bạn có thể liệt kê
        những thứ mình thích hoặc mong muốn. Thể hiện một cách đơn giản và nói về những sở thích của bạn hay đào sâu hơn
        và nói về những thứ bạn đang tìm kiếm ở bạn tương hợp. Để biết thông tin về những điều không nên đưa vào tiểu sử
        của mình, hãy kiểm tra phần Quy tắc Cộng đồng của chúng tôi.
      </div>
    ),
    showArrow: false,
  },
  {
    key: "3",
    label: "Cách hủy tương hợp với ai đó?",
    children: (
      <div className="text-secondary text-[16px]">
        Nếu bạn đang muốn đổi ý về một ai đó bạn đã tỏ ý thích trước đây không sao hết. Bạn có thể hủy tương hợp bất kỳ
        ai vào bất kỳ lúc nào. Hãy nhấn vào chiếc khiên màu xanh trong hồ sơ bạn tương hợp đó hoặc mục chat để chuyển
        tới Bộ công cụ an toàn và hủy tương hợp.
      </div>
    ),
    showArrow: false,
  },
  {
    key: "4",
    label: "Teklove tìm ra bạn tương hợp như thế nào?",
    children: (
      <div className="text-secondary text-[16px]">
        Kết nối bạn tương hợp chỉ hình thành khi cả hai thành viên đều dùng tính năng quẹt phải tỏ ý thích nhau.
      </div>
    ),
    showArrow: false,
  },
  {
    key: "5",
    label: "Chuyện gì xảy ra khi Teklove báo rằng bạn đã bỏ lỡ một bạn tương hợp?",
    children: (
      <div className="text-secondary text-[16px]">
        Khi chúng tôi báo rằng bạn đã bỏ lỡ một bạn tương hợp, có nghĩa là bạn đã dùng tính năng quẹt trái với người đã
        tỏ ý thích bạn.
      </div>
    ),
    showArrow: false,
  },
  {
    key: "6",
    label: "Sử dụng Teklove có miễn phí không?",
    children: (
      <div className="text-secondary text-[16px]">
        Các bạn có thể tải về Teklove miễn phí trên App Store và Cửa hàng Google Play. Các tính năng cơ bản cho phép bạn
        tạo hồ sơ, dùng tính năng quẹt phải để tỏ ý Thích ai đó và dùng quẹt trái để bỏ qua.
      </div>
    ),
    showArrow: false,
  },
];

const StyledCollapse = styled(Collapse)`
  .ant-collapse-header-text {
    color: #212529;
    font-weight: 500;
    font-size: 16px;
  }

  .ant-collapse-header {
    padding: 0 !important;
    margin-bottom: 8px;
  }
`;

const StyledPanel = styled(Panel)``;

const Page = () => {
  const [activeKey, setActiveKey] = useState<string[]>(["1"]);

  return (
    <div>
      <div className="sm:px-4 xs:px-[64px] xl:px-[108px] py-12 md:py-[64px] flex flex-col gap-9 md:gap-12 lg:gap-[64px]">
        <div className="text-center">
          <h1 className="text-third text-[24px] xs:text-[32px] lg:text-[48px] font-semibold mb-5">
            Câu hỏi thường gặp
          </h1>
          <h2 className="text-secondary text-[16px] md:text-[20px]">
            Nếu bạn đang cố gắng tìm hiểu kỹ hơn về chúng tôi, xin chúc mừng bạn đã đến{" "}
            <br className="hidden lg:block" />
            đúng nơi. Đây là phần giới thiệu nhanh về Teklove.
          </h2>
        </div>

        <StyledCollapse
          defaultActiveKey={["1"]}
          onChange={(key) => setActiveKey(key)}
          ghost
          className="flex flex-col gap-6 md:gap-8 w-full lg:w-[808px] mx-auto "
        >
          {items.map((item) => (
            <StyledPanel
              header={
                <div
                  className={`${
                    item.key === "1" ? "" : "border-[#EAECF0] border-t-[1px] pt-6"
                  } flex justify-between items-center text-[20px] text-third `}
                >
                  {item.label}
                  <Image
                    src={activeKey.includes(item.key) ? close : open}
                    alt="toggle-icon"
                    height={24}
                    width={24}
                    className="collapse-icon"
                  />
                </div>
              }
              key={item.key}
              showArrow={item.showArrow}
            >
              <div>{item.children}</div>
            </StyledPanel>
          ))}
        </StyledCollapse>

        <div className="bg-[#F9FAFB] rounded-2xl p-8 gap-8 flex flex-col mx-0 md:mx-8">
          <div className="mx-auto">
            <Image src={avatar} alt="avatar" width={120} height={56} />
          </div>

          <div className="text-center">
            <h1 className="text-third font-medium text-[20px]">Bạn có một câu hỏi khác?</h1>
            <h1 className="text-secondary text-[18px]">Bạn có thể tìm thấy câu trả lời khi liên hệ cho chúng tôi</h1>
          </div>

          <Link href={"/lien-he"} className="btn-primary h-12 w-[114px] mx-auto">
            Liên hệ
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Page;
